import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useBillingProviders} from '../hooks/useBillingProviders.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useBillingProviders();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
